import type { ReactNode } from 'react';

import { LazyMotion, domAnimation, m } from 'framer-motion';

/**
 * Loads only framer-motion's dom animation features (no drag/layout projection),
 * which keeps the gesture + projection engine out of the shared ui chunk.
 * Components under it must use `m.*` instead of `motion.*`.
 * Not `strict`: `Reorder` subtrees still render full `motion.*` components.
 */
const Motion = ({ children }: { children: ReactNode }) => (
  <LazyMotion features={domAnimation}>{children}</LazyMotion>
);

export { m };
export default Motion;
